import React, { useState, useEffect, useMemo } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import i18next from "i18next";
import { Link } from "react-router-dom";

import "./sales-agent.css";
import AasiLogo from "../../../../../../assets/certificate.svg";
import AajiLogo from "../../../../../../assets/warranty.svg";
import People from "../../../../../../assets/user.svg";

import { getAgentProfile } from "../../../../network/network";
import { AgentProfile, LICENSE_TYPE, License, SalesAgentProps } from "./sales-agent.types";
import { StatusCode } from "../../../../../../components/error-state/error-state";
import { getI18nData } from "../../form.util";
import { PROFILE_URL_DETAIL } from "./sales-agent.constants";

const SalesAgent = (props: SalesAgentProps) => {
  const { refId } = props;
  const [open, setOpen] = useState(false);
  const [agentProfile, setAgentProfile] = useState<AgentProfile | null>(null);
  const [loading, setLoading] = useState(false);
  const [errorStatus, setErrorStatus] = useState<StatusCode | "0">("0");
  const { t } = useTranslation();
  const curLang = i18next.language;
  const getData = () => {
    setLoading(true);
    getAgentProfile(refId)
      .then((res) => {
        setAgentProfile(res);
      })
      .catch((err) => {
        const status = get(err, "response.status", "-1"); // -1: unknown error by default
        setErrorStatus(status.toString() as StatusCode);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [refId]);

  const getLicenseAAJI = useMemo(() => {
    return agentProfile?.license?.find((d: License) => d.licenseType === LICENSE_TYPE.AAJI);
  }, [agentProfile]);
  const getLicenseAASI = useMemo(() => {
    return agentProfile?.license?.find((d: License) => d.licenseType === LICENSE_TYPE.AASI);
  }, [agentProfile]);

  if (loading) return <p className="reference-text text-center">{t("pp_loading_label")}</p>;
  if (errorStatus !== "0") return <></>;

  const profileDetailUrl = `${PROFILE_URL_DETAIL}/${refId}`;

  return (
    <div className="mt-5 sales-agent-wrapper   m-auto max-w-[1440px]">
      <p className="reference-text">
        {t("arl.agent-reference")} <b>{getI18nData(agentProfile?.name, curLang)}</b>,{" "}
        {t("arl.agent-code")} <b>{agentProfile?.agentCode}</b>
      </p>
      <div className="sales-agent-container">
        <button className="toggle-container" onClick={() => setOpen(!open)}>
          <p className="toggle-text">{t(`sales_agent.${!open ? "open" : "close"}`)}</p>
          {open ? (
            <KeyboardArrowUpIcon color="inherit" fontSize="small" />
          ) : (
            <KeyboardArrowDownIcon color="inherit" fontSize="small" />
          )}
        </button>
        {open && (
          <>
            <img
              src={agentProfile?.profilePictureUrl ? agentProfile?.profilePictureUrl : People}
              className="agent-avatar"
              alt="Agent Avatar"
            />
            <h1 className="agent-name">{getI18nData(agentProfile?.name, curLang)}</h1>
            <p className="agent-code">
              <i>
                {t("arl.agent-code")}: <b>{agentProfile?.agentCode}</b>
              </i>
            </p>
            <p className="domicile">
              <i>
                {t("arl.domicile")}: <b>{agentProfile?.domicile}</b>
              </i>
            </p>
            <div className="w-full border-b-[1px] border-[#f0f0f0] my-[24px]" />
          </>
        )}
      </div>
      {open && (
        <div className="license-container">
          {(getLicenseAASI || getLicenseAAJI) && (
            <p className="have-license">{t("sales_agent.have_license")}</p>
          )}
          {getLicenseAASI && (
            <div className="license-item">
              <img src={AasiLogo} className="w-[48px] h-[48px]" />
              <div className="ml-4">
                <p>
                  <b>{t("arl.license.aasi")}</b>
                </p>
                <p>
                  <i>{getLicenseAASI.licenseNumber}</i>
                </p>
              </div>
            </div>
          )}
          {getLicenseAAJI && (
            <div className="license-item">
              <img src={AajiLogo} className="w-[48px] h-[48px]" />
              <div className="ml-4">
                <p>
                  <b>{t("arl.license.aaji")}</b>
                </p>
                <p>
                  <i>{getLicenseAAJI.licenseNumber}</i>
                </p>
              </div>
            </div>
          )}

          {/* plai changes
          <div className="license-detail truncate">
            <p>{t("sales_agent.click_detail")}:</p>
            <Link to={profileDetailUrl}>{window.location.host + profileDetailUrl}</Link>
          </div>
          */}
        </div>
      )}
    </div>
  );
};

export default SalesAgent;
